import { useEffect, useState } from "react";
import { TriangleAlert } from "@thuthi/ui/icons";
import { Button } from "@thuthi/ui/components/button";
import { LoadingOverlay } from "@thuthi/ui/components/loading-overlay";
import { fetchCentralSession, redirectToCentralLogin } from "@thuthi/web-shared/central-auth";
import AvatarBox from "./AvatarBox";
import session from "../app/Session";
import routes from "./routes";

/**
 * 중앙 세션 브리지 — 자체 로그인 폼 대신:
 *  1) 중앙 세션(auth.thuthi.kr)이 없으면 공용 로그인으로 보낸다(로그인 후 이곳으로 복귀).
 *  2) 있으면 사용자 이름만 기억하고(로컬 DB 이름) 앱으로 간다. /api/v2 인증은 세션 쿠키 + nginx 가 한다.
 * /api/v2 가 401 을 주면 resetAndRedirect(routes.login) 로 여길 다시 지난다.
 * dev(localhost)는 .thuthi.kr 쿠키를 못 받으므로 확인을 건너뛴다 — 로컬 서버는 AUTH_DEV_USER 로 사용자를 정한다.
 */
const Login = () => {
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (import.meta.env.DEV) {
          session.store("dev");
          window.location.href = routes.app;
          return;
        }
        const central = await fetchCentralSession();
        if (cancelled) {
          return;
        }
        if (!central.authenticated || !central.username) {
          redirectToCentralLogin();
          return;
        }
        session.store(central.username);
        window.location.href = routes.app;
      } catch (e) {
        if (!cancelled) {
          setError((e as Error).message);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [attempt]);

  if (error) {
    return (
      <AvatarBox>
        <div className="flex items-center gap-2">
          <TriangleAlert className="text-destructive size-5 shrink-0" aria-hidden="true" />
          <p className="text-destructive text-sm">{error}</p>
        </div>
        <Button
          variant="outline"
          className="mt-4"
          onClick={() => {
            setError("");
            setAttempt((n) => n + 1);
          }}
        >
          다시 시도
        </Button>
      </AvatarBox>
    );
  }

  return <LoadingOverlay />;
};

export default Login;
